import React from 'react';

const MissionSection = () => {
  const values = [
  {
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FF5722" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>,
    title: 'Sikkerhet først',
    desc: 'Vi behandler dine data med høyeste sikkerhetsstandarder og er fullt GDPR-kompatible.'
  },
  {
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FF5722" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
    title: 'Sanntid & presisjon',
    desc: 'Oppdaterte bomtakster og trafikkdata i sanntid — alltid nøyaktige beregninger.'
  },
  {
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FF5722" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>,
    title: 'Kostnadsbesparelse',
    desc: 'Gjennomsnittlig sparer våre brukere 23% på bomkostnader gjennom smartere rutevalg.'
  },
  {
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FF5722" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>,
    title: 'Norsk ekspertise',
    desc: 'Bygget av nordmenn for nordmenn — vi kjenner det norske veinettet i detalj.'
  }];


  return (
    <section style={{ padding: '0 24px 80px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Mission statement */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '48px', alignItems: 'center', marginBottom: '80px' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <div style={{ width: '28px', height: '2px', background: '#FF5722' }} />
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#FF5722' }}>Vår misjon</span>
          </div>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '32px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.01em', lineHeight: 1.2, marginBottom: '20px' }}>
            Transparent og rettferdig
            <span style={{ display: 'block', color: 'rgba(224,228,232,0.5)', fontWeight: 400, fontSize: '0.75em' }}>bomhåndtering for alle</span>
          </h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '15px', color: 'var(--color-muted-foreground)', lineHeight: 1.8, marginBottom: '16px' }}>
            Vi tror at alle norske sjåfører fortjener full innsikt i hva de betaler på veien. Bomavgifter er komplekse — de varierer etter kjøretøytype, tidspunkt, abonnement og rute. Veiassistent gjør dette enkelt.
          </p>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '15px', color: 'var(--color-muted-foreground)', lineHeight: 1.8 }}>
            Fra privatpersoner som pendler daglig til store transportselskaper med hundrevis av kjøretøy — vi leverer presise, sanntidsoppdaterte beregninger som hjelper deg ta smarte beslutninger.
          </p>
        </div>
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', top: '-12px', left: '-12px', right: '12px', bottom: '12px', border: '2px solid rgba(255,87,34,0.12)', borderRadius: '2px', pointerEvents: 'none' }} />
          <div style={{ height: '320px', background: 'rgba(0,79,152,0.06)', border: '1px solid rgba(224,228,232,0.08)', borderRadius: '2px', overflow: 'hidden', position: 'relative' }}>
            <img
              src="https://img.rocket.new/generatedImages/rocket_gen_img_1682b282b-1766488897844.png"
              alt="Moderne kontormiljø med team som samarbeider rundt datamaskiner — Veiassistents utviklingsteam i Oslo"
              style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.55 }} />
            
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 40%, rgba(26,29,32,0.8) 100%)' }} />
            <div style={{ position: 'absolute', bottom: '20px', left: '20px', right: '20px' }}>
              <div style={{ display: 'flex', gap: '16px' }}>
                {[['Oslo', 'Hovedkontor'], ['Bergen', 'Avdeling'], ['Trondheim', 'Avdeling']]?.map(([city, role]) =>
                <div key={city} style={{ padding: '8px 12px', background: 'rgba(255,87,34,0.15)', border: '1px solid rgba(255,87,34,0.3)', borderRadius: '2px' }}>
                    <div style={{ fontFamily: 'var(--font-heading)', fontSize: '12px', fontWeight: 700, color: '#FF5722' }}>{city}</div>
                    <div style={{ fontFamily: 'var(--font-body)', fontSize: '11px', color: 'rgba(224,228,232,0.6)' }}>{role}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Values grid */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '32px' }}>
          <div style={{ width: '28px', height: '2px', background: '#FF5722' }} />
          <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#FF5722' }}>Våre verdier</span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
          {values?.map((v, i) =>
          <div key={i} style={{ padding: '28px', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(224,228,232,0.08)', borderTop: '2px solid rgba(255,87,34,0.4)', borderRadius: '2px', display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
              <div style={{ width: '44px', height: '44px', background: 'rgba(255,87,34,0.1)', border: '1px solid rgba(255,87,34,0.2)', borderRadius: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                {v?.icon}
              </div>
              <div>
                <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '16px', fontWeight: 600, color: 'var(--color-foreground)', marginBottom: '8px' }}>{v?.title}</h3>
                <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--color-muted-foreground)', lineHeight: 1.7 }}>{v?.desc}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default MissionSection;